import React, { useState, useEffect } from "react";

import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import EditIcon from "@material-ui/icons/EditTwoTone";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Typography from "@material-ui/core/Typography";
import DeleteIcon from "@material-ui/icons/DeleteTwoTone";
import GetIdIcon from "@material-ui/icons/InfoTwoTone";

const useStyles = makeStyles((theme) => ({
  avatar: {
    //  backgroundColor: grey[600],
  },
  small: {
    width: theme.spacing(2),
    height: theme.spacing(2),
  },
}));

const SettingsMenu = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const classes = useStyles();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (name) => {
    setAnchorEl(null);
  };

  const handleDelete = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleEdit = (event) => {
    props.ClickEdit();
  };

  return (
    <div>
      <IconButton
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => handleClose("UN")}
      >
      <MenuItem onClick={handleEdit}>
          <ListItemIcon>
            <GetIdIcon fontSize="small" />
          </ListItemIcon>
          <Typography variant="inherit">Get ID</Typography>
        </MenuItem>
        <MenuItem onClick={handleEdit}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <Typography variant="inherit">Edit</Typography>
        </MenuItem>
        <MenuItem onClick={handleDelete}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          <Typography variant="inherit">Delete</Typography>
        </MenuItem>
  
        {/* <MenuItem onClick={handleEdit}>Edit</MenuItem>
        <MenuItem onClick={handleDelete}>Delete</MenuItem>
        <MenuItem onClick={handleClose}></MenuItem> */}
      </Menu>
    </div>
  );
};
export default SettingsMenu;
